import { FETCH_METHODS, SearchConfig } from "../api.model"
import { OptionsFetchConfig } from "../common.model";
import { DataTableSchema, TableColumnSchema } from "../dynamic-data-table.model"
import { BrandDropdown, DealerDropdown, DefaultNumber, defaultSearchContainerButtons, EmpStatusDropdown, FieldNames, FirstNameText, IsCertJobRoleDropdown, JobCode, JobRoleDropdown, LastNameText, SpinIdNumber } from "../form-fields.model";
import { ButtonFieldConfig, DisplayTranformation, DynamicFormArray, FormFieldConfig, Props } from "../form.model"
import { TenureAreaOptions, tenureAreaRegionField, TenureDefaultTableSchema, TenureTitle } from "../tenure.model";

const JobTenureFilterField: FormFieldConfig = {
  ...structuredClone(DefaultNumber),
  fieldName: FieldNames['Tenure'],
  displayName: 'Job Tenure',
  fieldCriteriaConfig: {
    operators: [
      { value: 'less than', label: 'Less than', title: 'Less Than' },
      { value: 'greater than', label: 'Greater than', title: 'Greater Than' },
      { value: 'equal to', label: 'Equal to', title: 'Equal to' }
    ],
    value: 'equal to'
  }
}
export const JobTenureHistory = 'job_tenure_history'

const FormFieldArray: FormFieldConfig[] = structuredClone([
  SpinIdNumber, BrandDropdown,  
  {...structuredClone(tenureAreaRegionField),multiple:true, options:TenureAreaOptions}, 
  {...structuredClone(DealerDropdown),fieldName:FieldNames['DealerCode'], displayName: 'Dealer Code / Dealer Name', options:[], displayTranformation: DisplayTranformation.none, isAutoComplete: true, isLoading: true},
  {...structuredClone(JobRoleDropdown),displayName:'Job Title',fieldName:'jobDescription' ,isLoading:true, isAutoComplete:true}, JobCode,
  FirstNameText, LastNameText, EmpStatusDropdown, {...structuredClone(IsCertJobRoleDropdown), options:[{ fieldLabel: 'Yes', fieldValue: 'Yes' },{ fieldLabel: 'No', fieldValue: 'No' }],defaultValue: 'Yes'  },JobTenureFilterField
]);

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const JobRoleDynamicOptionSchema: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['JobRole'], keyValuePair: { fieldLabel: 'JobRoles', fieldValue: 'JobRoles' } }
    ],
    searchConfig: {
        method: FETCH_METHODS['Get'],
        path: 'jobCodes',
    }
}

const columnSchema: Array<TableColumnSchema> = [
  {
    label: 'Actions', fieldKey: 'brand_tenure_actions', fieldType: 'Actions', actionConfig: [
    {
      fieldKey: JobTenureHistory,
      iconClass: 'fa-solid fa-clock-rotate-left',
      toolTip: 'History'
    }]
  },
  { label: "SPIN ID", fieldKey: 'spinId' },
  { label: "Brand", fieldKey: 'brand' },
  { label: "FIRST NAME", fieldKey: 'firstName' },
  { label: "LAST NAME", fieldKey: 'lastName' },
  { label: "EMAIL", fieldKey: 'email' },
  { label: "JOB CODE",fieldKey:'jobCode' },
  { label: "JOB TITLE",fieldKey:'jobDescription' },
  { label: "EMPLOYEE STATUS", fieldKey: 'employeeStatus' },
  { label: "DEALER CODE", fieldKey: 'dealerCode' },
  { label: "DEALER NAME", fieldKey: 'dealerName' },
  { label: "Actual Job Tenure", fieldKey: 'actualTenureOverall', isCamelCaseHeader: true },
  { label: "Adjusted Job Tenure", fieldKey: 'adjustedTenureOverall' , isCamelCaseHeader: true },
  { label: "Total Tenure", fieldKey: 'jobTenure' , isCamelCaseHeader: true }
]

export const JobTenureTitle = 'Job Tenure'

export const JobTenureSearchConfig: SearchConfig = {
  method: FETCH_METHODS['Post'],
  path: "getJobTenure",
  body: {
    "area": "",
    "spinId": "",
    "firstName": "",
    "lastName": "",
    "EmployeeStatus": "",
    "Brand": "",
    "type": "BRAND"
  }
}

export const JobTenureHistorySearchConfig:SearchConfig = {
  method: "POST",
  path: "getTenureHistory",
  body:{
    [FieldNames['SpinId']]: '',
    brand: '',
    "type": "job",
    dealerCode:'',
    jobCode:''
  }
}

export const JobTenureFilterSchema: DynamicFormArray = {
  FieldsArray: FormFieldArray,
  ButtonsArray: FormButtonArray,
  searchConfig: JobTenureSearchConfig,
  autoSearchOnLoad:true
}

export const JobTenureTableSchema: DataTableSchema = {
  ...structuredClone(TenureDefaultTableSchema),
  columnSchema: columnSchema,
  exportConfig:{
    fileName: 'job_tenure',
    exportMessage:'Job Tenure data'
  },
  breadcrums: [{ level: 1, name: TenureTitle }, { level: 2, name: JobTenureTitle }]
}

export const note: Array<any> = [
    'Tenure displayed in Months'
]

export const JobTenureProps: Props = {
  isBreadCrumbSection: true,
  optionExplanation: note,
}